export default __webpack_public_path__ + "adminApplications.html";